import { COLOR_KEYS } from '../../../constants';

export const DEFAULT_VALUES = {
  title: 'Find your first Zap',
  backgroudColor: COLOR_KEYS.cream,
  defaultCtaHref: 'https://zapier.com/roles',
  ctaButtonText: 'Explore roles page',
  roles: [
    {
      name: 'Marketing',
      canonicalId: '0a326fb9-7108-4e93-84bd-d8ddffbd8aa1',
      href: 'https://zapier.com/roles/marketers',
    },
    {
      name: 'Business Owner',
      canonicalId: '511feb25-82b6-4a9f-81d6-83629a888016',
      href: 'https://zapier.com/roles/business-owners',
    },
    {
      name: 'IT',
      canonicalId: 'c97bc7dc-030f-44d5-9c23-61d4b77a25b0',
      href: 'https://zapier.com/roles/information-technology',
    },
    {
      name: 'Sales',
      canonicalId: '30a9520e-7e2c-4c86-9acc-4fd07d08c260',
      href: 'https://zapier.com/roles/sales',
    },
    {
      name: 'Support',
      canonicalId: '96f2f4e2-cbd6-40d5-a49e-322a714070bd',
      href: 'https://zapier.com/roles/customer-service',
    },
  ],
};
